module.exports = __webpack_public_path__ + "img/13.e0ca75d9.jpg";